import { makeAutoObservable } from 'mobx';
import { StreamChat } from 'stream-chat';

import { resetAllStore } from '../../shared/stores/resetAllStore';
import { chatService } from '../services/chatService';
import { ChatUser } from '../interfaces/chatInfo';

class ChatStore {
  user: ChatUser | null = null;
  userToken: string | null = null;
  chatClient: StreamChat | null = null;
  isOpenChat: boolean = false;
  activeChannelId: string | undefined = undefined;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.user = null;
    this.userToken = null;
    this.chatClient = null;
    this.isOpenChat = false;
    this.activeChannelId = undefined;
  }

  async getChatInfo() {
    const { userInfo, token } = await chatService.getChatInfo();
    this.setUser(userInfo);
    this.setUserToken(token);
  }

  setUser(user: ChatUser) {
    this.user = user;
  }

  setUserToken(userToken: string) {
    this.userToken = userToken;
  }

  setChatClient(chatClient: StreamChat) {
    this.chatClient = chatClient;
  }

  setIsOpenChat(isOpenChat: boolean) {
    this.isOpenChat = isOpenChat;
  }

  setActiveChannelId(activeChannelId: string | undefined) {
    this.activeChannelId = activeChannelId;
  }

  resetChat() {
    if (this.chatClient) {
      this.chatClient.disconnectUser();
      this.setDefaultValues();
    }
  }

  async openChatWithCustomer(customerId: number) {
    const channelId = await chatService.getChannelId(customerId);

    this.setActiveChannelId(channelId);
    this.setIsOpenChat(true);
  }
}

const chatStore = new ChatStore();

resetAllStore.addResetMethod(chatStore.resetChat);

export { chatStore, ChatStore };
